import * as S from './scrollBarIndicator.style';

export const ScrollableIndicator = () => <S.ScrollableIndicator />;
